export default __webpack_public_path__ + "static/angular-sviluppo-custom-b5275d27a676eb7161fd5cafed9f4890.jpg";